import { View, Text } from '@react-pdf/renderer';
import theme from '../../../theme';
import { PdfDocumentProps } from './ExportPdf';

export type PdfHeaderProps = Pick<PdfDocumentProps, 'caseDetails'>;

const PdfHeader = ({ caseDetails: data }: PdfHeaderProps) => {
    return (
        <>
            {data && (
                <>
                    <View
                        style={{
                            paddingVertical: 10,
                            backgroundColor: theme.palette.secondary.main
                        }}>
                        <Text
                            break
                            style={{
                                width: '97%',
                                margin: 'auto',
                                color: 'white',
                                fontSize: 23,
                                fontWeight: 'bold'
                            }}>
                            {data.caseNumber}
                        </Text>
                        {data.displayDueDate != null ? (
                            <Text
                                style={{
                                    width: '97%',
                                    margin: 'auto',
                                    color: 'white',
                                    fontSize: 13
                                }}>
                                {data.displayDueDate} - {data.displayDueTime + ' EST'}{' '}
                            </Text>
                        ) : (
                            ''
                        )}
                    </View>
                    <View style={{ padding: 3, backgroundColor: theme.palette.primary.main }}>
                        <Text
                            style={{
                                width: '97%',
                                margin: 'auto',
                                color: 'white',
                                fontSize: 10,
                                textAlign: 'center'
                            }}>
                            This is an <Text style={{ fontWeight: 'bold' }}>Audit</Text>{' '}
                            {data.userName && data.submittedDate && data.minutesTaken
                                ? `| Case was submitted by Dr. ${data.userName} at ${data.submittedDate} and took ${data.minutesTaken} minutes`
                                : ''}
                        </Text>
                    </View>
                </>
            )}
        </>
    );
};

export default PdfHeader;
